<!-- 关于我们 -->
<template>
  <div class="frame">
    <div class="banner">
      <div class="bg"></div>
    </div>
    <div class="box1">
      <div class="title-box">
        <div class="title">{{ $t("about.title") }}</div>
        <div class="en">{{ $t("about.en") }}</div>
        <div class="line"></div>
      </div>
      <div class="content">
        <p>
          <span>{{ $t("about.p1Highlight") }}</span
          >{{ $t("about.p1Text") }}
        </p>
        <div class="about-item">
          <div class="about-icon" aria-hidden="true">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="12"
                cy="12"
                r="9"
                stroke="currentColor"
                stroke-width="1.5"
              />
              <path
                d="M3 12h18M12 3c2.8 3.2 4.3 7.1 4.3 9s-1.5 5.8-4.3 9M12 3c-2.8 3.2-4.3 7.1-4.3 9s1.5 5.8 4.3 9"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
              />
            </svg>
          </div>
          <div class="about-item-content">
            <h3 class="about-item-title">{{ $t("about.p2Title") }}</h3>
            <p>{{ $t("about.p2Text") }}</p>
          </div>
        </div>
        <div class="about-item">
          <div class="about-icon" aria-hidden="true">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 4l7.5 4.33L12 12.66 4.5 8.33 12 4z"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linejoin="round"
              />
              <path
                d="M5.5 11.5L12 15.83l6.5-4.33M5.5 15.5L12 19.83l6.5-4.33"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <div class="about-item-content">
            <h3 class="about-item-title">{{ $t("about.p3Title") }}</h3>
            <p>{{ $t("about.p3Text") }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="box2">
      <div class="datas">
        <div class="data">
          <div class="num">
            <countTo
              ref="count1"
              :startVal="0"
              :endVal="12"
              :duration="3000"
              :autoplay="false"
            ></countTo>
            <span class="unit">{{ $t("about.stats.years") }}</span>
          </div>
          <div class="label">{{ $t("about.stats.yearsLabel") }}</div>
        </div>
        <div class="data">
          <div class="num">
            <countTo
              ref="count2"
              :startVal="0"
              :endVal="11"
              :duration="3000"
              :autoplay="false"
            ></countTo>
            <span class="unit">{{ $t("about.stats.services") }}</span>
          </div>
          <div class="label">{{ $t("about.stats.servicesLabel") }}</div>
        </div>
        <div class="data">
          <div class="num">
            <countTo
              ref="count3"
              :startVal="0"
              :endVal="30"
              :duration="3000"
              :autoplay="false"
            ></countTo>
            <span class="unit">+</span>
          </div>
          <div class="label">{{ $t("about.stats.team") }}</div>
        </div>
        <div class="data">
          <div class="num">
            <countTo
              ref="count4"
              :startVal="0"
              :endVal="98"
              :duration="3000"
              :autoplay="false"
            ></countTo>
            <span class="unit">%</span>
          </div>
          <div class="label">{{ $t("about.stats.satisfaction") }}</div>
        </div>
      </div>
    </div>
    <div class="box3">
      <div class="title-box">
        <div class="title">{{ $t("about.culture.title") }}</div>
        <div class="en">{{ $t("about.culture.en") }}</div>
        <div class="line"></div>
      </div>
      <div class="content">
        <div class="list">
          <div class="item" v-for="(item, index) in cultureItems" :key="index">
            <img :src="cultureImages[index]" class="post" />
            <div class="text">
              <div class="top">
                <div class="number">0{{ index + 1 }}</div>
                <div class="label">
                  <div class="title">{{ item.title }}</div>
                  <div class="en">{{ item.en }}</div>
                </div>
              </div>
              <div class="bottom">
                {{ item.desc }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import countTo from "vue-count-to";

export default {
  data() {
    return {
      countStart: false,
      cultureImages: [
        require("../assets/about/culture1.jpg"),
        require("../assets/about/culture2.jpg"),
        require("../assets/about/culture3.jpg"),
      ],
    };
  },
  components: { countTo },
  computed: {
    cultureItems() {
      return this.$t("about.culture.items");
    },
  },
  created() {},
  mounted() {
    let vm = this;
    window.onscroll = function () {
      if (this.scrollY > 300 && !vm.countStart) {
        vm.countStart = true;
        vm.$refs.count1.start();
        vm.$refs.count2.start();
        vm.$refs.count3.start();
        vm.$refs.count4.start();
      }
    };
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.frame {
  background-color: #f6fbff;
}

.banner {
  height: 80vh;

  .bg {
    width: 100%;
    height: 100%;
    background-image: url("../assets/source/about_banner.jpg");
    background-size: cover;
    background-position-x: center;
    background-attachment: fixed;
  }
}

.title-box {
  position: relative;
  color: #fff;
  text-align: center;

  .title {
    font-size: 34px;
    position: relative;
    z-index: 2;
  }
  .en {
    font-size: 40px;
    font-weight: bolder;
    letter-spacing: 3px;
    background-image: linear-gradient(
      to bottom,
      rgba(255, 255, 255, 0.5),
      transparent
    );
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    position: absolute;
    left: 50%;
    top: -40%;
    transform: translateX(-50%);
    z-index: 1;
  }
  .line {
    width: 40px;
    height: 3px;
    margin: 20px auto 30px;
    background-color: $theme;
  }
}
.box1 {
  height: 820px;
  background-image: url("../assets/about/box1_bg.jpg");
  background-size: cover;
  background-position-x: center;
  position: relative;

  &::before {
    content: "";
    display: table;
  }
  &::after {
    content: "";
    width: 100%;
    height: 100%;
    background-color: rgba($color: #000000, $alpha: 0.8);
    position: absolute;
    left: 0;
    top: 0;
    z-index: 0;
  }

  .title-box {
    margin-top: 200px;
    position: relative;
    z-index: 2;
  }

  .content {
    width: 1000px;
    margin: 70px auto 0;
    text-indent: 2em;
    position: relative;
    z-index: 2;

    p {
      font-size: 14px;
      color: #fff;
      line-height: 34px;

      span {
        font-weight: bold;
        font-size: 18px;
      }
    }

    .about-item {
      display: flex;
      align-items: flex-start;
      gap: 16px;
      margin-bottom: 24px;
      text-indent: 0;

      &:last-child {
        margin-bottom: 0;
      }

      .about-item-content {
        flex: 1;
        min-width: 0;
      }

      p {
        margin: 0;
        text-indent: 2em;
      }
    }

    .about-item-title {
      margin: 0 0 8px;
      font-size: 18px;
      font-weight: bold;
      color: #fff;
      text-indent: 0;
    }

    .about-icon {
      flex-shrink: 0;
      width: 56px;
      height: 56px;
      border-radius: 50%;
      background-color: rgba(253, 196, 75, 0.22);
      color: #fdc44b;
      display: flex;
      align-items: center;
      justify-content: center;

      svg {
        width: 28px;
        height: 28px;
      }

      .el-icon-office-building {
        font-size: 28px;
      }
    }
  }
}
.box2 {
  background-color: #1c202f;

  .datas {
    width: 1200px;
    margin: 0 auto;
    padding: 20px 0;
    display: flex;
    align-items: center;

    .data {
      width: 25%;
      height: 180px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .num {
        color: #fff;
        font-size: 60px;
        font-weight: bold;

        .unit {
          font-size: 20px;
        }
      }
      .label {
        margin-top: 10px;
        font-size: 14px;
        color: #9496a1;
      }
    }
  }
}
.box3 {
  background-color: #131625;

  &::before {
    content: "";
    display: table;
  }

  .title-box {
    margin-top: 100px;
  }

  .content {
    width: 1200px;
    margin: 50px auto 0;
    padding-bottom: 100px;

    .list {
      display: flex;
      justify-content: space-between;

      .item {
        width: 32%;
        position: relative;
        transition: 0.5s;

        &:hover {
          transform: translateY(-20px);
        }

        .post {
          width: 100%;
          height: 400px;
          object-fit: cover;
        }
        .text {
          width: 90%;
          padding: 20px;
          box-sizing: border-box;
          background-color: rgba(0, 0, 0, 0.6);
          color: #fff;
          position: absolute;
          left: 50%;
          bottom: -30px;
          transform: translateX(-50%);

          .top {
            display: flex;
            align-items: center;

            .number {
              font-size: 40px;
              font-weight: bold;
              color: $theme;
              margin-right: 15px;
            }
            .label {
              .title {
                font-size: 18px;
              }
              .en {
                font-size: 12px;
                color: #9496a1;
                margin-top: 5px;
              }
            }
          }
          .bottom {
            margin-top: 15px;
            font-size: 14px;
            color: rgb(193, 184, 210);
            line-height: 26px;
          }
        }
      }
    }
  }
}
</style>
